import React, { useEffect, useState } from "react";
import { DownloadSimple, Trash, MagnifyingGlass } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { API } from "../../lib/api";

export default function AdminLeads() {
  const [leads, setLeads] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/admin/leads").then(({ data }) => setLeads(data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const filtered = leads.filter(l =>
    !search ||
    l.name?.toLowerCase().includes(search.toLowerCase()) ||
    l.phone?.includes(search) ||
    l.city?.toLowerCase().includes(search.toLowerCase())
  );

  const exportCsv = async () => {
    try {
      const token = localStorage.getItem("orax_token");
      const res = await fetch(`${API}/admin/leads/export`, {
        credentials: "include",
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `orax-leads-${new Date().toISOString().slice(0,10)}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      toast.error("Export failed");
    }
  };

  const onDelete = async (id) => {
    if (!window.confirm("Delete this lead?")) return;
    await api.delete(`/admin/leads/${id}`);
    toast.success("Deleted");
    load();
  };

  return (
    <div data-testid="admin-leads">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
        <div>
          <h1 className="h2 text-[#0A1F15]">Leads</h1>
          <p className="text-[#5C7368]">{leads.length} total leads captured</p>
        </div>
        <button onClick={exportCsv} className="btn-blue !py-2.5 text-sm" data-testid="export-leads-btn">
          <DownloadSimple weight="bold" size={16}/> Export CSV
        </button>
      </div>

      <div className="bg-white rounded-2xl border border-[#E5E3DB] overflow-hidden">
        <div className="p-4 border-b border-[#E5E3DB]">
          <div className="relative max-w-md">
            <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#5C7368]"/>
            <input
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="Search by name, phone or city..."
              className="input-solar w-full pl-9 pr-4 py-2 rounded-lg border border-[#E5E3DB] text-sm"
              data-testid="lead-search"
            />
          </div>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-[#F9F8F6] text-left text-[#5C7368] uppercase text-xs tracking-wider">
              <tr>
                <th className="px-5 py-3">Name</th>
                <th className="px-5 py-3">Phone</th>
                <th className="px-5 py-3">City</th>
                <th className="px-5 py-3">Bill</th>
                <th className="px-5 py-3">Source</th>
                <th className="px-5 py-3">Message</th>
                <th className="px-5 py-3">Date</th>
                <th className="px-5 py-3"></th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={8} className="p-10 text-center text-[#5C7368]">Loading...</td></tr>
              ) : filtered.length === 0 ? (
                <tr><td colSpan={8} className="p-10 text-center text-[#5C7368]">No leads found.</td></tr>
              ) : filtered.map(l => (
                <tr key={l.id} className="border-t border-[#E5E3DB] hover:bg-[#F9F8F6]">
                  <td className="px-5 py-3 font-semibold text-[#0A1F15]">{l.name}</td>
                  <td className="px-5 py-3"><a href={`tel:${l.phone}`} className="text-[#0F52BA]">{l.phone}</a></td>
                  <td className="px-5 py-3">{l.city || "—"}</td>
                  <td className="px-5 py-3">{l.electricity_bill || "—"}</td>
                  <td className="px-5 py-3"><span className="text-xs px-2 py-0.5 rounded-md bg-[#F0EFEB]">{l.source || "—"}</span></td>
                  <td className="px-5 py-3 max-w-xs truncate text-[#5C7368]">{l.message || "—"}</td>
                  <td className="px-5 py-3 text-[#5C7368] whitespace-nowrap">{new Date(l.created_at).toLocaleString("en-IN")}</td>
                  <td className="px-5 py-3">
                    <button onClick={() => onDelete(l.id)} className="text-red-600 hover:bg-red-50 p-1.5 rounded" data-testid={`delete-lead-${l.id}`}>
                      <Trash size={16}/>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
